import Vue from 'vue';
import { mapGetters } from 'vuex';
import generator from 'generate-password';
import tooltip from '@/mixins/components/tooltip';
import { guid } from '@/mixins/guid';
import { cognitoMixins } from '@storm/mixins/cognito';
import dropsLoader from '@/mixins/components/drops-loader';
import { DEFAULT_PROFILE_PIC } from '@/constants';

export default Vue.component('storm-user-invite', {
  template: require('./template.html'),
  name: 'storm-user-invite',
  mixins: [cognitoMixins, guid],
  computed: {
    ...mapGetters(['stormSession']),
  },
  components: {
    dropsLoader,
    tooltip,
  },
  data() {
    return {
      loading: false,
      showNewPass: false,
      name: '',
      email: '',
      password: '',
      type: 'editor',
      showHintGroup: false,
      hint: {
        lc: false,
        uc: false,
        num: false,
        len: false,
        sym: false,
      },
    };
  },
  methods: {
    inviteUser() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.loading = true;
          const notification = {
            id: this.guid(),
            type: 'success',
            message: 'User invited successfully',
          };
          try {
            const { data } = await this.stormInvoke({
              data: {
                method: 'stormAddUser',
                name: this.name,
                email: this.email,
                pic: DEFAULT_PROFILE_PIC,
                type: this.type,
                password: this.password,
              },
            });
            this.$store.dispatch('addStormUser', data.user);
            this.$emit('back');
          } catch (e) {
            const message = e.message || e;
            notification.type = 'error';
            notification.message = message;
            this.$log.error(message);
          } finally {
            this.loading = false;
            this.$store.dispatch('addNotification', notification);
          }
        }
      });
    },
    showHint() {
      if (!this.showHintGroup) {
        this.showHintGroup = true;
      }
      const lc = /^(?=.*[a-z]).+$/;
      const uc = /^(?=.*[A-Z]).+$/; // uppercase letter
      const num = /^(?=.*\d).+$/; // a number
      const sym = /^(?=.*[!@#$%^&*_-]).+$/; // symbol
      const len = /^.{7,}.+$/; // at least 8 chars
      // check lowercase letter
      this.hint.lc = lc.test(this.password);
      // check uppercase letter
      this.hint.uc = uc.test(this.password);
      // check for a number
      this.hint.num = num.test(this.password);
      // check for symbol
      this.hint.sym = sym.test(this.password);
      // check password length
      this.hint.len = len.test(this.password);
    },
    generatePass() {
      const password = generator.generate({
        length: 12,
        symbols: true,
        numbers: true,
        uppercase: true,
        strict: true,
      });
      if (password.match(/!|@|#|\$|%|\^|&|\*|-|_/)) {
        this.password = password;
        this.showNewPass = true;
        this.showHint();
      } else {
        this.generatePass();
      }
    },
    resetHint() {
      this.showHintGroup = false;
      this.hint = {
        lc: false,
        uc: false,
        num: false,
        len: false,
        sym: false,
      };
    },
  },
});



// WEBPACK FOOTER //
// ./src/storm/pages/settings-modal/storm-users/invite/index.js